package com.trevorwiebe.timesheet.payPeriod.presentation

import com.trevorwiebe.timesheet.core.domain.model.Organization
import com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils.UiTimeSheet

data class StaticPayPeriodState(
    val timeSheets: List<UiTimeSheet> = emptyList(),
    val organization: Organization? = null
)